import React from "react";
import {Box, Chip, Typography} from "@mui/material";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";

const styles = {
    chipLabel: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.5rem"
    },
    icon: {
        fontSize: "1rem",
        color: "grey.600"
    }
};

export default function ShiftCountChip({count, onClick}) {
    return (
        <Chip
            onClick={onClick}
            label={
                <Box sx={styles.chipLabel}>
                    <Typography>{count}</Typography>
                    <AspectRatioIcon sx={styles.icon}/>
                </Box>
            }/>
    );
}